import request from './request';

/**
 * Admin shop API. Single-store: use getAll(perPage:1, status:'approved') for the one shop.
 */
const shopService = {
  getAll: (params) => request.get('dashboard/admin/shops/paginate', { params }),
  getById: (uuid, params) =>
    request.get(`dashboard/admin/shops/${uuid}`, { params }),
  update: (uuid, data) =>
    request.put(`dashboard/admin/shops/${uuid}`, data),
  selectPaginate: (params) =>
    request
      .get('dashboard/admin/shops/paginate', { params })
      .then((res) => res?.data ?? res ?? []),
};

export default shopService;
